import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {RoomCall} from "@/core/api/room.call.api";

class RoomCallLayoutApi extends BaseApi {

    constructor(props) {
        super(props);
        RoomCall.Layout = this
    }

    changeVideoLayout(params) {
        params.ignoreCallType = true;
        const {videoLayout} = Room.getRoomData().roomCall;
        
        if(params.layoutType !== videoLayout){
            Room.trigger('room_core_call_changeVideoLayout', params)
        }
    }
}

export const RoomCallLayout = new RoomCallLayoutApi()